import React from 'react';
import Modal from '../../../../_common/Modal/Modal';
import classes from '../../SinglePossiblePerson/HeaderTabs/header_tabs.module.scss';
import Button from '../../../../_common/Form/Buttons/Button';

function CancelModal({
  open, close, clearClick, activity,
}) {
  return (
    <Modal
      open={open}
      className={classes.note_cancel_modal}
      onClose={close}
    >
      <h2>{`Are you sure you want to clear this ${activity ? 'activity' : 'note'}?`}</h2>

      <div className={classes.note_cancel_modal_buttons_wrapper}>
        <Button
          className={classes.note_cancel_modal_button}
          onClick={clearClick}
          type="button"
          title="Yes"
          reverseColor
        />

        <Button
          onClick={close}
          type="button"
          title="Cancel"
          clearButton
        />
      </div>
    </Modal>
  );
}

export default CancelModal;
